import axios from 'axios';
import { showLoading, hideLoading  } from '../features/loader/loaderSlice';
import { store } from '../app/store';
import { Util } from './util';
import { clearSession } from '../features/login/LoginSlice';

axios.interceptors.request.use(
  config => {
    store.dispatch(showLoading());
    //Get token
    let accessToken = store.getState().login?.userObject?.accessToken;
    //if token is undefined, check local storage
    if (!accessToken) {
      const userObject = localStorage.getItem('userObject');
      if (userObject) {
        const user = JSON.parse(userObject);
        if (user && user.accessToken) {
          accessToken = user.accessToken;
        }
      }
    }
    if (accessToken) {
      config.headers['Authorization'] = 'Bearer ' + accessToken
      config.headers['Content-Type'] = 'application/json;charset=utf-8';
    }
    return config;
  },
  error => {
    Promise.reject(error)
  }
)

axios.interceptors.response.use(
    function (response) {
      store.dispatch(hideLoading()); 
      return response;
    },
    function (error) {
      store.dispatch(hideLoading()); 
      //Handle client error codes
      if(error.response.status >= 400 && error.response.status < 500){
          const errorMsg = error.response?.data?.error?.message;
          if(errorMsg){
            Util.showAlert(Util.alert_types.error, 'ERROR', errorMsg );
          }else{
            Util.showAlert(Util.alert_types.error, 'ERROR', 'Technical Error!Please try again after some time!' );
          }
          // Redirect to login on token expiration
          if ( error.response.status === 401 || error.response.status === 403)
          {
            store.dispatch(clearSession());
            localStorage.removeItem('userObject');
            setTimeout(() => {
              window.location.href = '/landing-page';
            }, 500);
          }
      }
      if(error.response.status === 500){
        Util.showAlert(Util.alert_types.error, 'ERROR', 'Technical Error!Please try again after some time!' );
      }
      return Promise.reject(error);
    }
  );